import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MemberRollCall } from 'src/app/models/memberRollCall';
import { MatTableDataSource, MatSnackBar, MatDialog, MatDialogRef, MatSort } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { ProgressSpinnerDialogComponent } from 'src/app/progress-spinner-dialog/progress-spinner-dialog.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AdministrationService } from '../../services/administration.service';

@Component({
  selector: 'app-member-pass-fail',
  templateUrl: './members-set-as-active.component.html',
  styleUrls: ['./members-set-as-active.component.scss']
})
export class MembersSetAsActive implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  role: string;
  constructor( private snackBar: MatSnackBar, private router: Router,
     private route: ActivatedRoute, private dialog: MatDialog,
      public authService : AuthenticationService,
      public adminService : AdministrationService) { }

  passFailMembers: MemberRollCall[] = [];
  selectedMembers: MemberRollCall[] = [];
  
  displayedColumnsSelect: string[] = ['id', 'firstName', 'lastName', 'dateOfBirth','email', 'select'];
  selectDataSource = new MatTableDataSource<MemberRollCall>(this.passFailMembers);
  selection = new SelectionModel<MemberRollCall>(true, this.selectedMembers);
  ngOnInit() {
    this.role = this.authService.getUserRole();
    this.adminService.GetUsersSetAsActive(this.role).subscribe((result: MemberRollCall[]) => {
      this.selectDataSource.data = result;
      this.selectDataSource.sort = this.sort;

    });
  }

  onBackClick() {
    this.router.navigate(['./users/']);
  }

  checkboxLabel(row?: MemberRollCall): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.selectDataSource.data.forEach(row => this.selection.select(row));
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.selectDataSource.data.length;
    return numSelected === numRows;
  }

  onSaveFailedMembers() {
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    const memberIds = [];
    this.selection.selected.forEach(s => memberIds.push(s.id));

    this.adminService.SetMembersAsActive("0", memberIds).subscribe(() => {
      dialogRef.close();
      this.router.navigate(['/users'], { relativeTo: this.route });
      this.snackBar.open('Failed members saved', '', {
        duration: 2000,
        panelClass: ['global-snackbar']
      });
    }, error => {
      dialogRef.close();
      this.snackBar.open('Error saving failed members.', '', {
        duration: 2000,
        panelClass: ['global-snackbar']
      });
    });
  }

  onEditMember(memberId: number) {
    this.router.navigate(['/users', memberId], { relativeTo: this.route });
  }
}
